const firebaseConfig = {
  apiKey: "AIzaSyAOmS-baXkpsj2WPQ0kJ1dc3--G2Wseh2k",
  authDomain: "medicine-shop-website.firebaseapp.com",
  projectId: "medicine-shop-website",
  storageBucket: "medicine-shop-website.appspot.com",
  messagingSenderId: "860505659216",
  appId: "1:860505659216:web:06dc3f1af8e4fb68f7be55"
};
export default firebaseConfig;